exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.dropdown-toggle { \r\n  cursor: pointer;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/React/Antique/src/app/bs-navbar/bs-navbar.component.css
// module id = ../../../../../src/app/bs-navbar/bs-navbar.component.css
// module chunks = 1